export default __webpack_public_path__ + "static/media/chest-purple-opened.0233ce61.png";